const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);


export const msalConfig = {
    auth: {
        clientId: "6b067ef8-6f3a-4b74-9397-02e4a1fc7d4a",
        authority: "https://login.microsoftonline.com/common",
        redirectUri: window.location.origin + "/sso/login/callback"
        // redirectUri:"https://uat.retailscanportal.com/sso/login/callback"
    },
    cache: {
        cacheLocation: isMobile ? "sessionStorage":"localStorage",
        storeAuthStateInCookie: false
    }
};

// Google SSO config for frontend libraries 
export const googleAuthConfig = {
    auth: {
        clientId: "325368880416-eaj3vbaiffquhod8r5oc7hbs19e43cek.apps.googleusercontent.com",
    }
};